export const ProcessFlow = {
  HARD_COPY_BEFORE_APPROVAL : "Hard Copy Before Approval",
  HARD_COPY_AFTER_APPROVAL : "Hard Copy After Approval",
  NO_HARD_COPY : "No Hard Copy",
  NO_FLOW : "No Flow",
}
